var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconWishlistHeartFilled = function SvgIconWishlistHeartFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 18 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#C62828",
    d: "M9 1.774a5 5 0 0 1 7.065 7.054l-7.066 7.076-7.065-7.076A5 5 0 0 1 9 1.774"
  })));
};
export default SvgIconWishlistHeartFilled;